import { render, staticRenderFns } from "./booking_item_result.vue?vue&type=template&id=1ab584db&"
import script from "./booking_item_result.vue?vue&type=script&lang=js&"
export * from "./booking_item_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports